import React from "react";

import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';

export const UpdateButton = (props) => {
	return <Button color="primary" startIcon={<EditIcon />} {...props}>Modifica</Button>;
}